module.exports = __webpack_public_path__ + "img/secton2.329530f8.png";